import { agentProductionTerms } from '../../../constants';
import { contactToolTips, tabModes } from '../../constants/agentProductionConstants';
import {
    COLUMN_GROUP_CONTACT, COLUMN_GROUP_SEARCH, COLUMN_GROUP_MLS, COLUMN_GROUP_GROWTH
} from '../../helpers/agentProductionHelpers';
import { getAdditionalColumnCount, transformSchemaTableColumns } from '../../helpers/schemaTableHelpers';

export const getContactInfoTableSettings = (columns, dateRangesText, tooltips = contactToolTips) => {

    const contactColumns = transformSchemaTableColumns(tooltips, tabModes.CONTACT_INFORMATION);

    const getCountDisplayedColumns = headerPlacement => columns.filter(c => c.isDisplayed &&
        c.headerPlacement === headerPlacement).length;


    const contactColumnsToAlwaysDisplay = ['agentName', 'office'];

    const addHeaderColumn = ({ headerColumns, title, colSpan, columnObjectName }) => {
        return {
            ...headerColumns,
            [columnObjectName]: {
                title,
                attrs: {
                    colSpan,
                    className: 'border text-center'
                }
            }
        };
    };

    let headerColumns = {};

    const countDisplayedColumnsContact
        = getCountDisplayedColumns(COLUMN_GROUP_CONTACT) + contactColumnsToAlwaysDisplay.length;
    if (countDisplayedColumnsContact) {
        const additionalAddressColumns = getAdditionalColumnCount(columns, contactColumns?.officeAddress.id);
        headerColumns = addHeaderColumn({
            headerColumns,
            title: 'Contact',
            colSpan: countDisplayedColumnsContact + additionalAddressColumns,
            columnObjectName: COLUMN_GROUP_CONTACT
        });
    }

    const countDisplayedColumnsSearch = getCountDisplayedColumns(COLUMN_GROUP_SEARCH);
    if (countDisplayedColumnsSearch) {
        headerColumns = addHeaderColumn({
            headerColumns,
            title: `${agentProductionTerms.currentSearch} (${dateRangesText.currentSearch.lastIntervalText}: ${dateRangesText.currentSearch.from} - ${dateRangesText.currentSearch.to})`,
            colSpan: countDisplayedColumnsSearch,
            columnObjectName: COLUMN_GROUP_SEARCH
        });
    }

    const countDisplayedColumnsMls = getCountDisplayedColumns(COLUMN_GROUP_MLS);
    if (countDisplayedColumnsMls) {
        headerColumns = addHeaderColumn({
            headerColumns,
            title: `${agentProductionTerms.allMlsTransactions} ${dateRangesText.allMls.lastIntervalText} (${dateRangesText.allMls.from} - ${dateRangesText.allMls.to})`,
            colSpan: countDisplayedColumnsMls,
            columnObjectName: COLUMN_GROUP_MLS
        });
    }

    const countDisplayedColumnsGrowth = getCountDisplayedColumns(COLUMN_GROUP_GROWTH);
    if (countDisplayedColumnsGrowth) {
        headerColumns = addHeaderColumn({
            headerColumns,
            title: 'Growth', colSpan: countDisplayedColumnsGrowth, columnObjectName: COLUMN_GROUP_GROWTH
        });
    }

    return [
        headerColumns
    ];
};
